import { Either, Option } from 'funfix-core';
import { Record } from 'immutable';
import { FETCH_FRONTEND_BOOTSTRAP_CONFIG, FETCH_HOST_CONFIG, FETCH_HOST_INFO, RECEIVE_FEATURE_FLAGS, RECEIVE_FEATURE_FLAGS_ERROR, RECEIVE_FRONTEND_BOOTSTRAP_CONFIG, RECEIVE_HOST_CONFIG, RECEIVE_HOST_CONFIG_ERROR, RECEIVE_HOST_INFO, RECEIVE_HOST_INFO_ERROR } from '../../actions/Configuration';
export const makeConfigurationState = Record({
  hostConfig: Option.empty(),
  hostInfo: Option.empty(),
  featureFlags: Option.empty(),
  frontendBootstrap: Option.empty()
});
export default function ConfigurationReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeConfigurationState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FETCH_HOST_INFO:
      return state.set('hostInfo', Option.empty());
    case RECEIVE_HOST_INFO:
      return state.set('hostInfo', Option.some(Either.right(action.hostInfo)));
    case RECEIVE_HOST_INFO_ERROR:
      return state.set('hostInfo', Option.some(Either.left(action.dataErrorMessages)));
    case FETCH_HOST_CONFIG:
      return state.set('hostConfig', Option.empty());
    case RECEIVE_HOST_CONFIG:
      return state.set('hostConfig', Option.some(Either.right(action.hostConfig)));
    case RECEIVE_HOST_CONFIG_ERROR:
      return state.set('hostConfig', Option.some(Either.left(action.dataErrorMessages)));
    case RECEIVE_FEATURE_FLAGS_ERROR:
      return state.set('featureFlags', Option.some(Either.left(action.dataErrorMessages)));
    case RECEIVE_FEATURE_FLAGS:
      return state.set('featureFlags', Option.some(Either.right(action.featureFlags)));
    case FETCH_FRONTEND_BOOTSTRAP_CONFIG:
      return state.set('frontendBootstrap', Option.empty());
    case RECEIVE_FRONTEND_BOOTSTRAP_CONFIG:
      return state.set('frontendBootstrap', Option.some(Either.right(action.frontendBootstrap)));
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
}
export const selectLaunchDarklyUserKey = state => state.frontendBootstrap.fold(() => {
  /* frontend bootstrap does not exist */
}, frontendBootstrapRes => frontendBootstrapRes.fold(() => {
  /* fetching frontend bootstrap had errors */
}, frontendBootstrap => frontendBootstrap.launchDarklyUserKey));